export enum InputState {
  Enabled = 'enabled',
  Hovered = 'hovered',
  Activated = 'activated',
  Disabled = 'disabled',
}
